module.exports = __webpack_public_path__ + "img/hands.104d396c.svg";